<script>
    import { onMount } from "svelte";
    import UIVariantModules from "./variant.modules.svelte";

    export let variants = [];
    export let startWith = 1;

    let maxCount = 0;
    let minCount = 1000;
    let showOnly = startWith;
    let moduleSets = [];
    let visibleVariants = [];

    $: {
        let _maxCount = 0;
        let _minCount = 10000;
        let _moduleSets = [];
        variants.forEach((itm) => {
            if (_maxCount < itm.value.length) {
                _maxCount = itm.value.length;
            }
            if (_minCount > itm.value.length) {
                _minCount = itm.value.length;
            }
            if (!_moduleSets.includes(itm.value.length)) {
                _moduleSets.push(itm.value.length);
            }
        });
        maxCount = _maxCount;
        minCount = _minCount;
        if (showOnly > maxCount || showOnly < minCount) {
            showOnly = minCount;
        }
        _moduleSets.sort((a, b) => (a < b ? -1 : 1));
        moduleSets = _moduleSets;
    }
    $: {
        if (moduleSets.includes(showOnly)) {
            visibleVariants = variants.filter(
                (itm) => itm.value.length === showOnly
            );
        } else {
            showOnly = showOnly - 1;
        }
    }

    function updateShowOnly(e) {
        const val = parseInt(e.currentTarget.value);
        //console.log("selected count of modules", val);
        showOnly = val;
    }
</script>

<div class="module-calc-variants">
    <div
        class="fixed-padding-left option-wide module-calc-count-selector-control"
        id="option_modules"
        data-name="_modules"
    >
        <label class="align-content-left" for="module-count-selector"
            ><span>Число модулей: {showOnly}</span>
        </label>
        <div
            class="btn-group"
            role="group"
            aria-label="Выбор числа модулей"
            id="module-count-selector"
        >
            {#each moduleSets as modulesCount}
                <button
                    type="button"
                    class={"btn btn--primary  " +
                        (showOnly === modulesCount ? "active" : "")}
                    on:click={() => {
                        showOnly = modulesCount;
                    }}>{modulesCount}</button
                >
            {/each}
        </div>
    </div>
    <div class="module-calc-variants-list">
        <div>
            {#each visibleVariants as variant}
                <UIVariantModules {...variant} on:click />
            {/each}
        </div>
    </div>
</div>
